module.exports = __webpack_public_path__ + "static/media/167.448871df.webp";